export default __webpack_public_path__ + "static/media/check-active-filled.1ddb86ea.svg";